import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import company from '@lba-dev/package.local-globals/company';

// Services & Configuration
import './utils/prototypes';
import './index.css';
import theme from './theme';
import store from './store';
import { initServices } from './services';
import { setupTokenManagement } from './services/auth';
import AppContent from './components/AppContent';


setupTokenManagement(store);
initServices();
document.title = company.name;

const App = () => (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AppContent />
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

export default App;

